import {ReactNode} from "react";
import useModal from "../../hooks/useModal.tsx";

interface BubbleModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  children: ReactNode;
  onAfterClose?: () => void;
}

export default function BubbleModal({ children, open, setOpen, onAfterClose }: BubbleModalProps) {

  const { dialogRef } = useModal(open, setOpen, onAfterClose);

  return (
    <dialog ref={dialogRef} className={'box-content z-50 fixed inset-[unset] left-1/2 top-1/2 -translate-1/2 m-0 w-full max-w-screen xs:w-[clamp(300px,40%,500px)] py-4 xs:py-6 px-0 xs:px-4 animation--sliding-up bg-white rounded-xl'}>
      {children}
    </dialog>
  )
}